<template>
  <div class="col-md-12 col-sm-12 footer-badge">
    <div class="row">
      <div class="col-md-3 col-sm-12">
        <a href="https://tryhackme.com/">
          <img src="https://tryhackme-badges.s3.amazonaws.com/FoobarBeer.png" alt="TryHackMe">
        </a>
      </div>
      <div class="col-md-3 col-sm-12">
        <div id="htb_badge_target" ref="htb_badge_target"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    // HTB dynamic badge is using document.write for adding the badge to the page, but expects to be added by <script>
    // tag directly to a page (which vue doesn't like) ... using the mounted() approach works, but doesn't allow the
    // write as the document is closed by now and can only be manipulated via DOM. The write needs to be temporarily
    // patched (and restored) to do the appendChild(...) call instead of the write. There could be a problem with race
    // condition in case anybody else would call the write before the image is loaded (!!) ...

    var orig = document.write
    document.write = function (str, patched) {
      if (patched) {
        orig(str, patched)
      } else {
        document.getElementById('htb_badge_target').innerHTML = str
      }
      document.write = orig
    }

    var script = document.createElement('script')
    script.setAttribute('src', 'https://www.hackthebox.eu/badge/140109"')
    this.$refs.htb_badge_target.appendChild(script)
  }
}
</script>

<style>
div#htb_badge_target {
  padding-top: 20px;
  padding-left: 34px;
}
</style>



// WEBPACK FOOTER //
// FooterBadge.vue?24579ee7